module.exports = __webpack_public_path__ + "img/stra1.c66ece9a.png";